import { Chip } from "@mui/material";

import {
    EmailLog,
    EmailLogAddress,
    EmailLogStatus,
} from "../../interfaces/emailLog";

export const EMAIL_LOG_STATUS: Record<
    EmailLogStatus,
    { label: string; color: "success" | "error" | "warning" }
> = {
    sent: { label: "Enviado", color: "success" },
    failed: { label: "Falhou", color: "error" },
    sending: { label: "Enviando", color: "warning" },
};

export function EmailLogStatusChip({ status }: { status: EmailLogStatus }) {
    const config = EMAIL_LOG_STATUS[status] ?? EMAIL_LOG_STATUS.sending;

    return (
        <Chip
            label={config.label}
            color={config.color}
            size="small"
            variant="outlined"
        />
    );
}

const SOURCE_LABELS: Record<string, string> = {
    MonthlyBillingMail: "Fatura",
    PaymentReceivedMail: "Pagamento recebido",
    GenericNotification: "Notificação ao cliente",
    CustomerNotification: "Notificação ao cliente",
    SendMailProposal: "Proposta",
    SendMailContractSigning: "Assinatura de contrato",
    WelcomeUserMail: "Boas-vindas (usuário)",
    WelcomeCustomerMail: "Boas-vindas (cliente)",
    AnaFormMail: "Formulário ANA",
    DefaultMail: "E-mail padrão",
    CustomMail: "E-mail personalizado",
};

const classBaseName = (value: string) => value.split("\\").pop() ?? value;

export function emailLogSource(
    log: Pick<EmailLog, "mailable" | "notification">
) {
    const source = log.notification ?? log.mailable;

    if (!source) {
        return "-";
    }

    const baseName = classBaseName(source);

    return SOURCE_LABELS[baseName] ?? baseName;
}

export function formatAddresses(addresses?: EmailLogAddress[] | null) {
    if (!addresses || addresses.length === 0) {
        return "-";
    }

    return addresses
        .map(({ address, name }) => (name ? `${name} <${address}>` : address))
        .join(", ");
}
